var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: " w-full h-auto",
    viewBox: "0 0 1360 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 208.632C0 208.632 63.9571 207.176 99 223C140.327 241.662 161.513 297.596 161.513 297.596C161.513 297.596 198.669 290.942 219.637 297.596C246.182 306.019 265.416 341.684 265.416 341.684C265.416 341.684 280.589 326.434 294.735 322.395C309.039 318.312 333.828 322.395 333.828 322.395C333.828 322.395 351.46 292.858 372.92 282.244C389.033 274.274 419.804 282.244 419.804 282.244C412.59 279.059 464.72 205.228 526.203 208.632C592.003 212.275 640.724 286.513 633.707 286.967C633.707 286.967 666.31 267.172 691.316 264.53C723.107 261.17 763.14 282.244 763.14 282.244C763.14 282.244 794.776 254.099 819.395 245.635C842.935 237.541 885.234 241.304 885.234 241.304C885.234 241.304 870.557 160.414 902.219 128.048C936.786 92.7111 1030.63 90.932 1030.63 90.932C1030.63 90.932 1034.69 44.8466 1099.87 39.7247C1167.26 34.4288 1184.08 90.932 1184.08 90.932C1184.08 90.932 1200.44 68.1252 1214.76 63.8269C1235.5 57.6026 1270.5 76.7608 1270.5 76.7608C1270.5 76.7608 1278.14 33.3116 1303.42 16.9267C1321.52 5.19315 1360 0 1360 0V446H0V208.632Z",
    fill: "url(#paint0_linear_225_130)",
    fillOpacity: 0.29
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_225_130",
    x1: 513,
    y1: 355.5,
    x2: 1282.23,
    y2: 23.2105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4E4E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.ea55866609eccf587ed0a71abe09a420.svg";
export { ForwardRef as ReactComponent };